import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./plugins/fontawesome.js";
import loadscript from "vue-plugin-load-script";

Vue.config.productionTip = false;

new Vue({
  router,
  loadscript,
  render: (h) => h(App),
}).$mount("#app");
